import Vue from 'vue';
import SumoPopover from './plugin_overrides/SumoPopover';

Vue.use(SumoPopover);
